
import AboutText from './components/abouttext'

function About() {
	return(
		<div className="pageWrapper">
			<div className="page page-about">
				<AboutText />
			</div>
		</div>
	)
}

export default About;